import { render, staticRenderFns } from "./MenuDetailsNew.vue?vue&type=template&id=665c6b8e&scoped=true&"
import script from "./MenuDetailsNew.vue?vue&type=script&lang=js&"
export * from "./MenuDetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./MenuDetailsNew.vue?vue&type=style&index=0&id=665c6b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c6b8e",
  null
  
)

export default component.exports